import { useState } from 'react';
import Select from 'react-select';
import { Card, CardBody, CardHeader, Container, Button } from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { useGetLookupInfosQuery } from 'src/rtk/features/setup/lookup/lookupInfoApi';
import DefaultTable from './DefaultTable';
import DetailsTable from './DetailsTable';
import AddLookup from './AddLookup';

export const Lookup = () => {
  const { data: lookups } = useGetLookupInfosQuery();

  const lookupList = lookups?.data || [];

  const [activeLookup, setActiveLookup] = useState('');
  const [uuid, setUuid] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  const options =
    lookupList.map((item) => ({ value: item.id, label: item.lookup_name })) ||
    [];

  return (
    <div className="page-content">
      <Container fluid>
        <div className='page-breadcrumb-wrapper'>
          <BetterBreadcrumb
            breadcrumbItem={[{ link: '#', name: 'Lookup' }]}
            title={'Lookup'}
          />
          <div>
            <Button color="primary" onClick={() => setShowAddForm(true)}>
              Add Lookup
            </Button>
          </div>
        </div>

        <Card>
          <CardHeader>
            <div className="row justify-content-between flex-row-reverse">
              <div className="col-sm-4 col-md-4">
                <Select
                  isSearchable={true}
                  options={options}
                  name='something'
                  placeHolder="Select Lookup"
                  onChange={(e: { label: any; value: any }) => {
                    setActiveLookup(e?.label || '');
                    setUuid(e?.value || '');
                  }}
                />
              </div>

              {activeLookup !== '' && (
                <div className="col-sm-4 col-md-2">
                  <Button
                    color="secondary"
                    size="md"
                    onClick={() => {
                      setActiveLookup('');
                      setUuid('');
                    }}
                  >Back</Button>
                </div>
              )}
            </div>
          </CardHeader>
          <CardBody>
            {activeLookup === '' ? (
              <DefaultTable
                lookupList={lookupList}
                setActiveLookup={setActiveLookup}
                setUuid={setUuid}
              />
            ) : (
              <DetailsTable
                lookupList={[]}
                setActiveLookup={setActiveLookup}
                uuid={uuid}
              />
            )}
          </CardBody>
        </Card>
        <AddLookup isOpen={showAddForm} toggle={() => setShowAddForm(!showAddForm)}  />
      </Container>
    </div>
  );
};
